import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const BaseTitle = styled.span`
  font-family: Poppins;
  letter-spacing: 0%;
  color: ${palette.neutral[900]};
`

export const JumboTitle = styled(BaseTitle)<{
  $emphasized?: boolean
  $fontSizeOverride?: number
}>`
  font-weight: ${({ $emphasized }) => ($emphasized ? 600 : 400)};
  font-size: ${({ $fontSizeOverride }) =>
    $fontSizeOverride ? `${$fontSizeOverride}px` : '36px'};
  line-height: 54px;

  @media (max-width: 480px) {
    font-size: 24px;
    line-height: 36px;
  }
`

export const DescriptionText = styled(BaseTitle)<{ fontColor?: string }>`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ fontColor }) => fontColor || palette.neutral[900]};
  a,
  strong,
  em,
  code {
    color: ${({ fontColor }) => fontColor || palette.neutral[900]};
  }
`

export const LargeText = styled(BaseTitle)<{ $isBold?: boolean }>`
  font-weight: ${({ $isBold }) => ($isBold ? 600 : 400)};
  font-size: 16px;
  line-height: 21px;
`
export const MediumText = styled(BaseTitle)<{ $isBold?: boolean }>`
  font-weight: ${({ $isBold }) => ($isBold ? 600 : 400)};
  font-size: 14px;
  line-height: 21px;
`

export const SmallText = styled(BaseTitle)`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
`

export const TinyText = styled(BaseTitle)`
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
`
